var map = {
	"./de/cv-play.png": "LKKJ",
	"./en/cv-play.png": "DdRd",
	"./es/cv-play.png": "MdGi",
	"./fr/cv-play.png": "Bnkw",
	"./ja/cv-play.png": "T27w",
	"./ko/cv-play.png": "uQ1d",
	"./pt/cv-play.png": "bkSX",
	"./ru/cv-play.png": "oHyK",
	"./tc/cv-play.png": "goFn",
	"./th/cv-play.png": "0SGH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wjwl";